import React from 'react';
import { Modal, Form, Input, Checkbox, Button, Space, InputNumber, Select, Divider } from 'antd';
import { layout, tailLayout, formStyle } from 'containers/common/layout';

interface IProps {
    dataId: number,
    editorVisible: boolean,
    editorTitle: string,
    onCancel: any,
}

const { Option } = Select;
const { TextArea } = Input;

class AftersaleEdit extends React.Component<IProps> {
    constructor(props: any) {
        super(props);
    }

    state = {
        visible: false,
        reject: false
    };

    cancelModal = () => {
        this.setState({
            reject: false,
        });
        this.props.onCancel();
    }

    onFinish = (values: any) => {
        console.log('Success:', values);
    };

    onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    onChange = (value: any) => {
        if (value == 1) {
            this.setState({
                reject: false
            })
        } else if (value == 2) {
            this.setState({
                reject: true
            })
        }
    }

    render() {
        return (
            <div>
                <Modal
                    title={this.props.editorTitle}
                    visible={this.props.editorVisible}
                    onCancel={this.cancelModal}
                    footer={null}
                    destroyOnClose={true}
                    maskClosable={false}
                >
                    <Form
                        {...layout}
                        name="basic"
                        initialValues={{ remember: true }}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        size="large"
                        style={formStyle}
                    >
                        <Form.Item
                            label="处理结果"
                            name="type"
                            rules={[{ required: true, message: 'Please select!' }]}
                        >
                            <Select
                                onChange={this.onChange}
                                style={{ width: '100%' }}
                            >
                                <Option value="1">同意</Option>
                                <Option value="2">拒绝</Option>
                            </Select>
                        </Form.Item>

                        {
                            this.state.reject &&
                            <Form.Item
                                label="拒绝理由"
                                name="reasonType"
                                rules={[{ required: true, message: 'Please select!' }]}
                            >
                                <Select
                                    style={{ width: '100%' }}
                                >
                                    <Option value="1">情况不符合实际</Option>
                                    <Option value="2">该行程不支持退款</Option>
                                </Select>
                            </Form.Item>
                        }

                        <Form.Item
                            label="备注"
                            name="remark"
                        >
                            <TextArea rows={4}></TextArea>
                        </Form.Item>

                        <Divider />

                        <Form.Item {...tailLayout}>
                            <Space size="large">
                                <Button onClick={this.cancelModal}>取消</Button>
                                <Button type="primary" htmlType="submit">确认提交</Button>
                            </Space>

                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        )
    }
}

export default AftersaleEdit;